export default __webpack_public_path__ + "static/media/ionic-ios-add-circle-outline.c5b87656.svg";